import { Application } from '@/types/application';
import { Detail } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { VariableRef } from '@/types/variable';
import { isArray, isObject } from '@/util/typeGuards';
import { valueUtil } from './value';

export const valueListUtil = (): ValidationObject<(VariableRef | string)[] | undefined> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const values = getValue(configuration, details);

    if (!values?.length) {
      if (configuration.required) {
        errors.push({
          severity: 'error',
          message: `Block ${blockName} is missing required values in valuelist ${configuration.label}`,
          id: nodeId
        });
      }
    } else {
      values.map((value) => {
        const valueErrors = valueUtil().validate(
          application,
          metadata,
          linkedSubroutineId,
          nodeId,
          blockName,
          configuration,
          value as Detail
        );
        if (valueErrors.length) {
          errors.push(...valueErrors);
        }
      });
    }
    return errors;
  };

  const getValue = (configuration: Configuration, obj: unknown): (VariableRef | string)[] | undefined => {
    if (!obj) return;
    const initVal = obj;
    if (isArray(initVal)) {
      return initVal as (VariableRef | string)[];
    } else if (isObject(obj)) {
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate,
    getValue
  };
};
